document.addEventListener("DOMContentLoaded", () => {
  const view = document.querySelector(".view-medical-specialties-list");
  if (!view) return;

  const cityGroups = view.querySelectorAll(".city-group");
  const dropdownItems = document.querySelectorAll("[data-select-city-id]");

  if (!cityGroups.length || !dropdownItems.length) return;

  // --------------------------------------------------
  // Show selected city
  // --------------------------------------------------
  const showCity = (cityId) => {
    cityGroups.forEach((group) => {
      group.style.display =
        group.getAttribute("data-city-id") === cityId ? "" : "none";
    });
  };

  // --------------------------------------------------
  // Initial state
  // --------------------------------------------------
  const firstItem = dropdownItems[0];
  if (firstItem) {
    const cityId = firstItem.getAttribute("data-select-city-id");
    showCity(cityId);
    firstItem.classList.add("selected");
  }

  // --------------------------------------------------
  // Click handling
  // --------------------------------------------------
  dropdownItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      dropdownItems.forEach((i) => i.classList.remove("selected"));
      item.classList.add("selected");

      showCity(item.getAttribute("data-select-city-id"));
    });
  });
});
